/* istanbul ignore file */
/* eslint-disable */
__webpack_public_path__ = window.__webpack_public_path__;

export default __webpack_public_path__;
